import { Chip } from "@mui/material";
import { ArrayField, Datagrid, FunctionField, NumberField, TextField } from "react-admin";
import { settings } from "app";

const AuthorsSection = () => (
  <ArrayField
    source="authors"
    sort={{ field: "order", order: "ASC" }}
  >
    <Datagrid
      bulkActionButtons={false}
      rowClick={false}
      sx={settings.style.secondaryDatagrid}
    >
      <NumberField
        source="order"
        label="№"
        sortable={false}
      />
      <TextField
        source="fullName"
        label="Име"
        sortable={false}
      />
      <TextField
        source="orcid"
        label="ORCID"
        emptyText="-"
        sortable={false}
      />
      <TextField
        source="authorIdentifier"
        label="Идентификатор (Scopus / WoS)"
        emptyText="-"
        sortable={false}
      />
      <TextField
        source="affiliation"
        label="Афилиация"
        emptyText="-"
        sortable={false}
      />
      <FunctionField
        label="Автор за кореспонденция"
        render={author =>
          author.isCorrespondingAuthor ? (
            <Chip
              label="Да"
              color="success"
              size="small"
            />
          ) : (
            "-"
          )
        }
      />
    </Datagrid>
  </ArrayField>
);

export default AuthorsSection;
